import { memo } from 'react'
import { useTranslation } from 'react-i18next'

import type { FormActionsProps } from './FormActions.types'

const FormActions = (props: FormActionsProps) => {
  const { onSubmit, onCancel, disabled } = props
  const { t } = useTranslation()

  return (
    <div className="flex justify-end gap-3 pt-4 items-center">
      {onCancel && (
        <button
          type="button"
          disabled={disabled}
          className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
          onClick={onCancel}
        >
          {t('Tenants.Profile.Licenses.Form.Actions.Cancel')}
        </button>
      )}

      <button
        type="button"
        disabled={disabled}
        className="px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition"
        onClick={onSubmit}
      >
        {t('Tenants.Profile.Licenses.Form.Actions.Save')}
      </button>
    </div>
  )
}

export default memo(FormActions)
